import { controllerFactory } from "@utils/createController";

export default class extends controllerFactory<HTMLDivElement>()({
  targets: {
    bannerContainer: HTMLDivElement,
    bannerTemplate: HTMLTemplateElement,
    submit: HTMLButtonElement,
  },
}) {
  statusResponse = false;

  checkDeliverability() {
    const conversationId = document
      .querySelector("main")!
      .getAttribute("data-conversation-id");

    fetch(`/conversations/${conversationId}/deliverability`, {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
    })
      .then((response) => {
        if (!response.ok) {
          throw new Error("Network response was not ok");
        }

        return response.json();
      })
      .then((data) => {
        data.forEach((response) => {
          if ((this.statusResponse = response.status)) {
            // show banner if NOT deliverable
            if (response.deliverable) {
              this.resetButton();
              return;
            }

            const banner =
              this.bannerTemplateTarget.content.firstElementChild?.cloneNode(
                true,
              ) as HTMLDivElement;

            const message = banner.querySelector(
              "[data-target-message]",
            ) as HTMLDivElement;
            message.textContent = response.message;

            const button = banner.querySelector(
              "[data-target-button]",
            ) as HTMLAnchorElement;
            button.textContent = response.button_text;
            button.setAttribute("href", response.button_url);

            this.submitTarget.disabled = true;
            this.submitTarget.setAttribute("data-conversation-valid", "false");

            this.bannerContainerTarget.append(banner);
          } else {
            this.resetButton();
          }
        });
      })
      .catch((error) => console.error("Error:", error));
  }

  connect() {
    this.checkDeliverability();
  }

  internalCheckboxChange(event: Event) {
    if (this.statusResponse) {
      this.submitTarget.disabled = !(event.target as HTMLInputElement)?.checked;
    }
  }

  resetButton() {
    this.submitTarget.disabled = false;
    this.submitTarget.setAttribute("data-conversation-valid", true);
  }
}
